<template>
  <div class="form-pf-esi">
    <tl-checkbox
        label="Enable PF"
        v-model="pfesi.pf_enabled"
      >
    </tl-checkbox>
    <div v-if="pfesi.pf_enabled" class="threeColumnGrid">
      <txt label='Enter UAN no.' type="text" v-model="pfesi.uan_number"></txt>
      <txt label='PF No.' type="text" v-model="pfesi.pfno"></txt>
       <div>
        <span class="input-label">PF Enrollment Date</span>
      <date-picker type="text" v-model="pfesi.pf_enrollment_date"/>
       </div>
      <txt label='Nominee’s Name' type="text" v-model="pfesi.nomniee_name"></txt>
      <div>
        <span class="label color">Date Of Birth</span>
        <date-picker @datevalue="(val)=>pfesi.nomniee_dob=val" :value="pfesi.nomniee_dob"></date-picker>
      </div> 
      <!-- <txt label='Relationship' type="text"></txt> -->
      <tl-select label="Relationship" 
          :options="['Aunt','Brother','Daughter','Father','Grandfather','Grandmother',
              'Guardian','Husband','Mother','Sister','Son','Uncle','Wife']"
          :value="pfesi.relationship"
          @change="(val)=>pfesi.relationship=val"/>
    </div>

    <tl-checkbox
        label="Entitled to ESI"
        v-model="pfesi.entitled_esi"
      >
    </tl-checkbox>
    <txt v-if="pfesi.entitled_esi" label='ESI No.' type="text" v-model="pfesi.esi_number"></txt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // pf_enabled: false,
      eligibleMinWage: true,
      lwf: null,
      regType: null,
      //arushi
      
      pfesi:{
        pf_enabled: false,
        // uan_number:'',
        // pfno:'',
        // nomniee_name:'',
        // nomniee_dob:'',
        entitled_esi: false,
        // esi_number:''
      }
    }
  },
  watch:{
      pfesi: function(val) {
          //console.log('pfesi',val)
          this.$emit('pfesi',val)
        },
     deep: true
    },
}
</script>

<style lang="scss" scoped>
.form-pf-esi {
  *:nth-child(n) {
    margin-bottom: 15px;
  }
}
.color{
  color: #6e6e6e;
  font-size: 12px;
}
</style>
